<template>
  <div class="solubility">
    <Head :title="$ml.get(`SOLUBILITY, ${$store.getters['unit/getLabel']('g/L')}`) " />
    <div>
      <app-text-input
        v-for="(value, key, i) in general.data.Solubility"
        :key="key"
        :label="getLabel(i)"
        hint="g/L"
        v-model="general.data.Solubility[key]"
        type="number"
        min="0"
        max="2500"
        :digits-after-dot="2"
      />
    </div>
  </div>
</template>

<script>
import Head from './helps/Head.vue';

export default {
  props: {
    general: Object
  },
  components: {
    Head
  },
  methods: {
    getLabel(i) {
      return this.$store.getters['unit/convert']('C', i*5) + " " + this.$store.getters['unit/getLabel']('C')
    }
  }
}
</script>

<style lang="scss" scoped>
  .solubility {
    width: 100%;

    > div:last-child {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      margin-top: 40px;
      margin-left: -5px;
      margin-right: -5px;
      > div {
        margin: 15px 5px;
        width: 96px;
        padding: 1px;
      }
      @media (max-width: 768px) {
        justify-content: space-between;
        > div {
          margin: 0 0 32px 0;
          width: calc(50% - 8px);

        }
      }
    }
  }
</style>
